import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private router: Router
    ) { }

    public isLoggedIn() {
        let token = localStorage.getItem('token');
        return !!token;
    }

    public getBearerToken() {
        let token = localStorage.getItem('token');
        if (!token) {
            return null;
        }
        token = JSON.parse(token);
        if (token) {
            return token['access_token'];
        } else {
            return null;
        }
    }

    public getRefreshToken() {
        let token = localStorage.getItem('token');
        if (!token) {
            return null;
        }
        token = JSON.parse(token);
        if (token) {
            return token['refresh_token'];
        } else {
            return null;
        }
    }

    public getSession() {
        let token = localStorage.getItem('token');
        if (!token) {
            return null;
        }
        token = JSON.parse(token);
        if (token) {
            return token['session'];
        } else {
            return null;
        }
    }

    public logout() {
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
    }
}
